import api from "../../store/services/api";

/**
 * 99Food (DiDi Food) integration.
 *
 * Authorizing on 99Food's page does not bind a store: the store's super-admin authorizes
 * our app there, and then `connectFood99Store` binds it with 99Food's store id (shopId)
 * and caches its token. For a store that is already bound it just revalidates the token.
 */

export const listFood99Stores = () => api.get("/food99/stores/");

export const getFood99AuthorizationPage = () =>
  api.post("/food99/stores/authorization-page/", {});

export const connectFood99Store = (restaurantId, shopId) =>
  api.post("/food99/stores/connect/", {
    restaurant_id: restaurantId,
    ...(shopId ? { shop_id: shopId } : {}),
  });

export const disconnectFood99Store = (restaurantId) =>
  api.post("/food99/stores/disconnect/", { restaurant_id: restaurantId });

/**
 * openapiOnly = true forces every confirmation through Slapie (99Food mode 2).
 * false also allows the store to confirm from 99Food's own app (mode 1, their default).
 */
export const setFood99ConfirmMethod = (restaurantId, openapiOnly) =>
  api.post("/food99/stores/confirm-method/", {
    restaurant_id: restaurantId,
    openapi_only: openapiOnly,
  });

export const getFood99CancelCodes = (channelOrderId) =>
  api.get(`/food99/cancel-codes/?oid=${channelOrderId}`);
